


// components/helpers/authHelpers.js

import Parse from '../../parseConfig';

export const isGuestUser = (user) => {
  return user && user.getUsername && user.getUsername() === 'guest@planhub.app';
};

export const forceLogout = async ({ redirectToWelcome = true } = {}) => {
  console.log('[AuthHelpers] Forcing logout...');

  await Parse.User.logOut();
  localStorage.removeItem('guestLastActiveAt');

  if (redirectToWelcome) {
    const currentUrl = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.replace(`/?redirectTo=${currentUrl}`);
  } else {
    window.location.reload(); // Fallback if you don't want special handling
  }
};



